import type { ComponentProps, FC } from 'react';
import { makeStyles } from 'vendor/material';
import {
  fontWeightMedium,
  fontWeightMediumLarge,
} from 'utils/fontWeightConstants';
import { Tag as BaseTag } from 'packages/cosell/src/components/Tag/Tag';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'grid',
    gap: theme.spacing(1),
    minHeight: '100%',
    color: '#253858',
    fontSize: theme.typography.pxToRem(12),
    paddingInline: theme.spacing(1),
  },
  row: {
    display: 'flex',
    gap: theme.spacing(2),
    height: 'max-content',
    '& > dl': {
      flexBasis: '50%',
      flexGrow: 1,
    },
  },
  detail: {
    fontSize: 'inherit',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    margin: 0,
  },
  title: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: fontWeightMediumLarge,
    lineHeight: theme.typography.pxToRem(20),
    margin: 0,
  },
  value: {
    margin: 0,
  },
  tag: {
    '& span': {
      fontSize: `12px !important`,
      fontWeight: fontWeightMedium,
      color: theme.palette.NEUTRAL700,
      letterSpacing: '0.3px',
    },
  },
}));

const Tag: FC<ComponentProps<typeof BaseTag>> = ({ children }) => {
  const classes = useStyles();
  return (
    <span className={classes.tag}>
      <BaseTag>{children}</BaseTag>
    </span>
  );
};

const SummaryData = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();
  return <div className={classes.content}>{children}</div>;
};

const Row: FC = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.row}>{children}</div>;
};

const Detail: FC<{ title: React.ReactNode }> = ({ children, title }) => {
  const classes = useStyles();
  return (
    <dl data-testid="detail" className={classes.detail}>
      <dt className={classes.title}>{title}</dt>
      <dd className={classes.value}>{children}</dd>
    </dl>
  );
};

SummaryData.Row = Row;
SummaryData.Detail = Detail;
SummaryData.Tag = Tag;

export default SummaryData;
